import React, { useState } from 'react';
import './Diagnosis.scss';
import { App, Button, Popconfirm, Popover, Space } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { getDiagnosis } from '../../network/encounters';
import { ModalAppDiagnosis } from '../../components/upeosoft/ModalApp/ModalApp';
import { deleteDiagnosis } from '../../network/Diagnosis';
import Heading from '../../components/common/Heading/Heading';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { PlusOutlined } from '@ant-design/icons';
const Diagnosis = ({ t }) => {
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState('');
  const [searchText, setSearchText] = useState('');
  const client = useQueryClient();
  const { message } = App.useApp();

  const { data: diagnosis, isLoading } = useQuery({
    queryKey: [queryKeys.getDiagnosis],
    queryFn: () => getDiagnosis(),
    keepPreviousData: true,
  });
  const { mutate: deleteDiagnosisMutation } = useMutation({
    mutationKey: ['deleteDiagnosis'],
    mutationFn: (id) => deleteDiagnosis(id),
    onSuccess: (data) => {
      if (data?.message?.status === 500) {
        message.error(data?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getDiagnosis],
      });
    },
    onError: (error) => {
      message.error(error);
    },
  });
  return (
    <div className="Diagnosis">
      <Heading title={t.settings} subTitle={t.diagnosis} path="" />
      <div>
        {/* <Flex align="center" justify="space-between" style={{ width: '100%' }}>
          <h3>{t.diagnosis}</h3>
        </Flex> */}
        <div style={{ margin: '30px 0 10px' }}>
          <DynamicTableAnt
            data={diagnosis?.message?.diagnosis}
            columns={[
              {
                title: t.diagnosis,
                dataIndex: 'diagnosis',
                key: 'diagnosis',
                filteredValue: [searchText],
                onFilter: (value, record) => {
                  const name = String(record?.diagnosis).toLowerCase();
                  const searchValue = value.toLowerCase();
                  // console.log(record);
                  return name.includes(searchValue);
                },
              },
              {
                title: t.action,
                dataIndex: 'action',
                key: 'action',
                width: '20%',
                render: (text, record) => {
                  return (
                    <Space>
                      <Popover
                        placement="top"
                        title={t.edit}
                        onClick={() => {
                          setOpen(true);
                          setEdit(true);
                          setEditId(record?.name);
                        }}
                      >
                        <Button size="small" type="primary">
                          <MdModeEditOutline />
                        </Button>
                      </Popover>
                      <Popconfirm
                        title={t.deletetheDiagnosis}
                        description={t.areYouSure}
                        okText={t.yes}
                        cancelText={t.no}
                        onConfirm={() => deleteDiagnosisMutation(record?.name)}
                      >
                        <Button size="small" type="primary" danger>
                          <MdDelete />
                        </Button>
                      </Popconfirm>
                    </Space>
                  );
                },
              },
            ]}
            loading={isLoading}
            setSearchText={setSearchText}
            Placeholder={t.SearchByDiagnosis}
            rowKey="key"
            scroll={{ x: 'max-content' }}
            // className="table"
            buttonModal={
              <Button
                type="primary"
                onClick={() => {
                  setOpen(true);
                  setEdit(false);
                  setEditId('');
                }}
              >
                <PlusOutlined
                  style={{
                    fontSize: '10px',
                  }}
                />
                {t.AddDiagnosis}
              </Button>
            }
          />
        </div>
      </div>
      <ModalAppDiagnosis
        t={t}
        open={open}
        setOpen={setOpen}
        edit={edit}
        editId={editId}
        setEditId={setEditId}
      />
    </div>
  );
};

export default Diagnosis;
